import { Select, MenuItem, SelectChangeEvent, useTheme } from "@mui/material";

interface ISortDropdownProps {
  setSortBy: (value: string) => void;
  sortBy: string;
  options: { value: string; label: string }[];
}

const SortDropdown: React.FC<ISortDropdownProps> = ({
  setSortBy,
  sortBy,
  options,
}) => {
  const theme = useTheme();
  const handleChange = (event: SelectChangeEvent) => {
    setSortBy(event.target.value);
  };

  return (
    <Select
      value={sortBy}
      onChange={handleChange}
      displayEmpty
      size="small"
      sx={{
        background: theme.palette.mode === "dark" ? "#191C24" : "#FFFFFF",
        padding: "8px 0px",
        borderRadius: "5px",
        fontWeight: "600",
        fontSize: "12px",
        height: "32px",
        color: theme.palette.mode === "dark" ? "#ffffff" : "inherit",
        "& .MuiOutlinedInput-notchedOutline": {
          border: theme.palette.mode === "dark" ? "1px solid #2D2D2D" : "1px solid #E9E9ED",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          border: theme.palette.mode === "dark" ? "1px solid #2D2D2D" : "1px solid #E9E9ED",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: theme.palette.mode === "dark" ? "1px solid #2D2D2D" : "1px solid #E9E9ED",
        },
        "& .MuiSelect-icon": { 
          color: theme.palette.mode === "dark" ? "#ffffff" : "#585874" 
        },
        "& .MuiPaper-root": {
          backgroundColor: theme.palette.mode === "dark" ? "#191C24" : "#FFFFFF",
        },
        "& .MuiMenuItem-root": {
          color: theme.palette.mode === "dark" ? "#ffffff" : "inherit",
          "&:hover": {
            backgroundColor: theme.palette.mode === "dark" ? "#2D2D2D" : "rgba(0, 0, 0, 0.04)",
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{ fontSize: "12px" }}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SortDropdown;
